
// ==============================================

//        READER BAR

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {


  //        Sliders slick
  // ==============================================
  if ($('#reader-bar').length) {

    var el       = $('.article__body');    // element servant de répère pour la barre de lecture ( ou $(document))
    var elH      = $(el).innerHeight();    // hauteur totale de l'élément (padding inclus)
    var elY      = $(el).offset().top;     // position Y de l'élément dans la page
    var winH     = $(window).height();     // hauteur de la fenêtre
    var elMax    = elH - winH;             // hauteur "utile" de l'élément'
    var scrolled = $(document).scrollTop(); // position de scroll de la page

// console.log('elMax', elMax);
// console.log('elH', elH);
// console.log('elY', elY);

    // Scroll de la page
  	$(document).on('scroll',function() {
      scrolled = $(document).scrollTop();

      // force to refresh
      elH   = $(el).innerHeight();
      elMax = elH - winH;
      // console.log('scroll elH / elMax / scrolled', elH, elMax, scrolled);
      renderReadBar();
  	});

    // Resize de la page
    $(window).on('resize', function() {
      winH  = $(window).height();
      elH   = $(el).innerHeight();
      elY   = $(el).offset().top;
      elMax = elH - winH;
      // console.log('resize elH', elMax);
      renderReadBar();
    });


    // Update la largeur de la barre de lecture
    function renderReadBar() {
      var pct =  (scrolled - elY) * 100 / elMax;
      pct = Math.max(0, Math.min(pct, 100));

  		// Calcul de la largeur de la barre
  		var barW = pct + "%";

          //Formule mathématique pour calculer p le pourcentage de progression
          // var t = (scrolled / elH) * winH;
          // var barW = Math.ceil((scrolled + t) / elH * 110) + 1 + "%";

  		$(".reader-bar__bar").css("width", barW);

      // ∆∆∆∆ debug
      // var status = Math.floor(pct) + "%";
      // status += " | " + scrolled + "px" + " / " + elMax + "px";
      // $(".reader-bar__status").html(status);
    }

  }

})
